import { http } from '../../../api'
const apiUrl = '/user'
const user = {
  namespaced: true,
  state: {
    dataList: [],
    currencyList: [],
    users: [],
    itemData: null
  },
  actions: {
    getAllData: ({ commit }, params) => {
      let url = apiUrl
      if (params) {
        const q = new URLSearchParams(params)
        url = url + '?' + q.toString()
      }
      return http.get(url).then(res => {
        commit('setList', res.data.data)
        return res.data
      })
    },
    create: ({ commit }, params) => {
      return http.post(apiUrl, params).then(res => {
        return res.data
      })
    },
    delete: ({ commit }, params) => {
      return http.delete(apiUrl + '/' + params.id + '?reason=' + params.reason).then(res => {
        commit('setDelete', params.id)
      })
    },
    deleteForce: ({ commit }, params) => {
      return http.delete(apiUrl + '/' + params.id + '/force').then(res => {
        commit('setRemoveList', params.id)
      })
    },
    restore: ({ commit }, params) => {
      return http.post(apiUrl + '/' + params.id + '/restore').then(res => {
        commit('setRestore', params.id)
      })
    },
    loginUser: ({ commit }, params) => {
      return http.post(apiUrl + '/' + params.id + '/login').then(res => {
        return res.data.data
      })
    },
    goWeb: ({ commit }, params) => {
      return http.post(apiUrl + '/' + params.id + '/login').then(res => {
        return res.data.dat
      })
    },
    blocked: ({ commit }, params) => {
      return http.post(apiUrl + '/' + params.id + '/block', params).then(res => {
        commit('setBlocked', res.data.data)
      })
    },
    unblock: ({ commit }, params) => {
      return http.post(apiUrl + '/' + params.id + '/unblock').then(res => {
        commit('setBlocked', res.data.data)
      })
    },
    deleteFileMedia: ({ commit }, id) => {
      return http.delete(`/media/${id}/delete`).then(res => {
      })
    },
    getCreateData: ({ commit }) => {
      return http.get(apiUrl + '/create').then(res => {
        return res.data
      })
    },
    getData: ({ commit }, params) => {
      return http.get(apiUrl + '/' + params.id).then(res => {
        commit('setData', res.data.data)
      })
    },
    update: ({ commit }, params) => {
      return http.post(apiUrl + '/' + params.id, params.data).then(res => {
      })
    }
  },
  mutations: {
    setList (state, data) {
      state.dataList = data
    },
    setRemoveList (state, id) {
      state.dataList = state.dataList.filter(item => item.id !== id)
    },
    setBlocked (state, data) {
      console.log(data)
      state.dataList = state.dataList.map(item => {
        if (item.id === data.id) {
          item.blocked = !item.blocked
          if (!item.blocked) {
            item.blocked_reason = null
          } else {
            item.blocked_reason = data.blocked_reason
          }
        }
        return item
      })
    },
    setDelete (state, id) {
      state.dataList = state.dataList.map(item => {
        if (item.id === id) {
          item.deleted_at = 'deleted_at'
        }
        return item
      })
    },
    setRestore (state, id) {
      state.dataList = state.dataList.map(item => {
        if (item.id === id) {
          item.deleted_at = null
        }
        return item
      })
    },
    setData (state, data) {
      state.itemData = data
    }
  },
  getters: {
    dataList: state => state.dataList,
    itemData: state => state.itemData
  }
}

export default user
